import React from 'react';
import { Button } from '@getgrover/ui';
import { useLogin } from './useLogin';

export const LocalDevAuthButton = () => {
  const { login } = useLogin();
  return (
    <Button onClick={login} variant="Primary">
      Login
    </Button>
  );
};
